export default {
  ["Дата начала продаж {date}"]: (date?: string) =>
    `Müügi alguskuupäev ${date}`,
  ["Закрыть"]: "Sulge",
  ["Рекламный слайдер"]: "Reklaami slaider",
  ["Используйте клавиши стрелок для переключения слайдов."]:
    "Kasutage slaidide vahetamiseks nooleklahve.",
  ["Ещё"]: "Veel",
  ["Ещё {number}"]: (number?: number) => `${number} veel`,
  ["Убрать"]: "Eemalda",
  ["Меню"]: "Menüü",
  ["От {min} до {max} символов"]: (data?: { min: number; max: number }) =>
    `${data?.min} kuni ${data?.max} tähemärki`,
  ["Минимум {count} символ"]: (count?: number) => `Vähemalt ${count} tähemärki`,
  ["Выбрать из списка"]: "Valige nimekirjast",
  ["развернуто"]: "Laiendatud",
  ["свернуто"]: "Kokku pandud",
  ["Модальное окно"]: "Modaalaken",
  ["Выбран"]: "Valitud",
  ["Не выбран"]: "Pole valitud",
  ["Свернуть"]: "Ahenda",
  ["Эксклюзив"]: "Eksklusiivne",
  ["Хит продаж"]: "Enimmüüdud",
  ["Новинка"]: "Uudis",
  ["Все книги, получившие эту награду"]:
    "Kõik raamatud, mis said selle auhinna",
  ["Предыдущий слайд"]: "Eelmine slaid",
  ["Следующий слайд"]: "Järgmine slaid",
  ["Оценить книгу на {count} балл из 5"]: (count?: number) =>
    `Hinda raamatut ${count} punktiga viiest`,
  ["Снять оценку"]: "Eemalda hinnang",
  ["{star} звезда из 5"]: (star: number | undefined = 0) =>
    `${star} ${star > 1 ? "tärni" : "tärn"} viiest`,
  ["предыдущий таб"]: "Eelmine kaart",
  ["следующий таб"]: "Järgmine kaart",
};
